import { useEffect, useState } from "react";
import { Col, Row, Container } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import FloatingButtons from "./frontend/FloatingButtons";
import GoogleReviews from "./frontend/GoogleReviews";
import CustomSlickSlider from "./frontend/CustomSlickSlider";
import DownloadApp from "./DownloadApp";
import ChatBot from "./CustomChatBot";
import { GiSpeedBoat } from "react-icons/gi";
import { fetchPublicBlogs } from "./utils/blogApi";
import BlogCard from "./frontend/BlogCard";


export default function About() {
  const [recentBlogs, setRecentBlogs] = useState([]);
  const navigate = useNavigate();


  useEffect(() => {
    window.scrollTo(0, 0);
    loadRecentBlogs();
  }, []);

  const loadRecentBlogs = async () => {
    try {
      const data = await fetchPublicBlogs({ limit: 3, page: 1 });
      if (data.success) {
        setRecentBlogs(data.blogs);
      }
    } catch (err) {
      console.error("Error loading recent blogs:", err);
    }
  };


  return (
    <>
      <FloatingButtons />
      <ChatBot />

      {/* ── Original About Content ── */}

      {/* Hero / About BBR */}
      <section className="cs-bg-dark py-5 cs-section">
        <Container>
          <Row className="align-items-center mb-5">
            <Col lg={5}>
              <h2 className="fw-bold text-white mb-4">
                ABOUT <span style={{ color: "#ddb467" }}>BBR</span>
              </h2>
              <p className="text-white mb-4">
                BBR Boat Rentals is a USA-based booking platform that helps boat owners and fishing charter operators earn income and manage bookings.
              </p>
              <p className="text-white mb-4">
                BBR was founded in 2021 to fill a clear market gap. Tournament ready bass boats were not available to rent on any lakes, despite strong demand from serious anglers. BBR was created to solve that problem.
              </p>
              <p className="text-white mb-4">
                Today, BBR is the Home of the Tournament Ready Bass Boat, with a mission to make these boats accessible on every recognized bass fishing lake in the United States.
              </p>
              <p className="text-white">
                We provide secure payments, direct communication with customers, and simple tools to operate your rental or charter business efficiently.
              </p>
            </Col>
            <Col lg={7}>
              <Row>
                <Col xs={12} className="mb-3">
                  <img
                    src="/assets/frontend/images/statsBg.webp"
                    alt="BBR Boat on Water"
                    className="img-fluid rounded shadow-lg"
                    style={{ width: "100%", height: "300px", objectFit: "cover" }}
                  />
                </Col>
                <Col xs={6}>
                  <div className="p-4 border border-secondary rounded h-100 d-flex flex-column justify-content-center" style={{ backgroundColor: "#1a1a1a" }}>
                    <h2 className="fw-bold fs-1 mb-0" style={{ color: "#ddb467" }}>2021</h2>
                    <p className="text-muted small mb-0 spacing-1">ESTABLISHED</p>
                  </div>
                </Col>
                <Col xs={6}>
                  <div className="p-2 p-lg-4 border border-secondary rounded h-100 d-flex align-items-center justify-content-between" style={{ backgroundColor: "#ddb467" }}>
                    <div>
                      <div className="d-flex align-items-center">
                        <h2 className="fw-bold fs-1 mb-0 text-black">USA</h2>
                        <img src="/assets/backend/images/flags/us_real.svg" alt="USA Flag" className="d-sm-none ms-2" style={{ width: "40px", borderRadius: "4px", border: "1px solid #fff" }} />
                      </div>
                      <p className="text-black small mb-0 spacing-1">NATIONWIDE</p>
                    </div>
                    <div className="flex-shrink-1 d-none d-sm-block">
                      <img src="/assets/backend/images/flags/us_real.svg" alt="USA Flag" className="img-fluid" style={{ maxWidth: "80px", width: "100%", opacity: 0.9, borderRadius: "6px", border: "3px solid #fff" }} />
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          {/* Benefit Cards */}
          <Row className="g-4 mb-5">
            <Col lg={6}>
              <div className="p-5 h-100 rounded" style={{ backgroundColor: "#111", border: "1px solid #333" }}>
                <div className="mb-4">
                  <GiSpeedBoat style={{ fontSize: "40px", color: "#ddb467" }} />
                </div>
                <h3 className="text-white fw-bold mb-3 text-uppercase">For Boat Owners</h3>
                <p className="text-secondary mb-4">
                  Your boat can generate income when you are not using it. BBR provides everything needed to list your boat and accept bookings securely.
                </p>
                <h6 className="fw-bold mb-3" style={{ color: "#ddb467", fontSize: "0.8rem", letterSpacing: "1px" }}>BENEFITS</h6>
                <ul className="list-unstyled text-white">
                  {[
                    "Bass Boat renters are Verified",
                    "Start with 10% commission",
                    "Reduce your commission to 0% with our pro staff referral system.",
                    "Secure messaging with renters",
                    "Simple calendar and availability management",
                    "Instant checkout and secure payments",
                    "Full control of your boat, pricing, and availability",
                    "Choose who you rent to",
                    "iOS and Android Apps",
                    "Chatbot 24/7 support",
                  ].map((item, index) => (
                    <li key={index} className="d-flex align-items-start mb-2">
                      <span className="me-2" style={{ color: "#ddb467" }}>✔</span>
                      <span style={{ fontSize: "0.9rem" }}>{item}</span>
                    </li>
                  ))}
                </ul>
                <p className="text-secondary mt-4 fst-italic border-top border-secondary pt-3">
                  BBR provides the infrastructure. You keep control and earn income from your boat.
                </p>
              </div>
            </Col>

            <Col lg={6}>
              <div className="p-5 h-100 rounded" style={{ backgroundColor: "#111", border: "1px solid #333" }}>
                <div className="mb-4">
                  <i className="material-icons" style={{ fontSize: "40px", color: "#ddb467" }}>business_center</i>
                </div>
                <h3 className="text-white fw-bold mb-3 text-uppercase">For Fishing Charter and Boat Rental Businesses</h3>
                <p className="text-secondary mb-4">
                  BBR provides a complete booking platform for fishing charter operators and rental businesses. Our system helps you reduce fees, increase bookings, and manage your business efficiently.
                </p>
                <h6 className="fw-bold mb-3" style={{ color: "#ddb467", fontSize: "0.8rem", letterSpacing: "1px" }}>BENEFITS</h6>
                <ul className="list-unstyled text-white">
                  {[
                    "Start with 10% commission. Or 5% with a referral code",
                    "Reduce your commission down to 0% with our pro staff referral system.",
                    "Secure messaging with customers",
                    "Simple calendar and booking management",
                    "Instant checkout and secure payments",
                    "Full control of your bookings and pricing",
                  ].map((item, index) => (
                    <li key={index} className="d-flex align-items-start mb-2">
                      <span className="me-2" style={{ color: "#ddb467" }}>✔</span>
                      <span style={{ fontSize: "0.9rem" }}>{item}</span>
                    </li>
                  ))}
                </ul>
                <p className="text-secondary mt-4 fst-italic border-top border-secondary pt-3">
                  BBR helps charter operators keep more revenue and operate independently.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Banner */}
      <section className="py-5 bg-black" style={{ borderTop: "1px solid #222", borderBottom: "1px solid #222" }}>
        <Container>
          <Row className="justify-content-center text-center">
            <Col lg={10}>
              <h2 className="fw-bold text-white text-uppercase mb-2">
                BUILT FOR <span style={{ color: "#ddb467" }}>SERIOUS ANGLERS</span> AND <br /> PROFESSIONAL OPERATORS
              </h2>
              <div style={{ width: "60px", height: "3px", backgroundColor: "#ddb467", margin: "20px auto" }} />
              <p className="text-secondary mb-0">
                BBR connects verified boat owners and professional charter operators with renters through a secure, USA-based platform.
              </p>
              <p className="text-secondary mt-2">
                Boat owners and charter operators use BBR to earn income and grow their business. Renters use BBR to access trusted, tournament-ready boats and professional fishing charters.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Start Listing Today */}
      <section className="py-5" style={{ backgroundColor: "#ddb467" }}>
        <Container>
          <Row className="align-items-center">
            <Col lg={8}>
              <h2 className="fw-bold text-black text-uppercase mb-3">START LISTING TODAY</h2>
              <p className="text-black mb-0" style={{ maxWidth: "600px" }}>
                Listing your boat or charter on BBR is simple. Once listed, you can accept bookings, receive secure payments, and manage everything from one platform.
              </p>
              <p className="text-black fw-bold mt-2 border-start border-dark border-3 ps-3">
                BBR helps you earn from your boat and expand access to tournament-ready bass boats across the United States.
              </p>
            </Col>
            <Col lg={4} className="text-lg-end mt-4 mt-lg-0">
              <Link to="/dashboard" className="btn btn-lg px-5 py-3 fw-bold text-uppercase rounded-0 mb-3 btn-black-custom">
                LIST NOW
              </Link>
              <div className="d-flex flex-column align-items-end">
                <p className="text-black mb-1">Already have an account? <Link to="/auth" className="fw-bold text-decoration-underline link-hover-white">Log In</Link></p>
                <p className="text-black mb-0">Need help? Visit our <Link to="/faq" className="fw-bold text-decoration-underline link-hover-white">FAQ</Link></p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Featured Boats */}
      <section className="my-5">
        <Container>
          <Row>
            <Col xs={12} className="my-2">
              <h1 className="fw-bold text-white mt-2">Featured Boats</h1>
            </Col>
          </Row>
          <Col xs={12}>
            <CustomSlickSlider />
          </Col>
        </Container>
      </section>

      {/* Recent Blog Posts */}
      {recentBlogs.length > 0 && (
        <section className="py-5" style={{ backgroundColor: "#111" }}>
          <Container>
            <Row className="mb-4">
              <Col xs={12} className="d-flex justify-content-between align-items-center">
                <h2 className="fw-bold text-white mb-0">
                  Latest From Our <span style={{ color: "#ddb467" }}>Blog</span>
                </h2>
                <Link
                  to="/blog"
                  className="btn px-4 py-2 fw-bold text-uppercase"
                  style={{ backgroundColor: "#ddb467", color: "#000", borderRadius: "0", fontSize: "0.85rem" }}
                >
                  View All Posts
                </Link>
              </Col>
            </Row>
            <Row>
              {recentBlogs.map((blog) => (
                <Col key={blog.id} lg={4} md={6} sm={12} className="mb-4">
                  <BlogCard blog={blog} />
                </Col>
              ))}
            </Row>
          </Container>
        </section>
      )}

      <DownloadApp />

      {/* Google Reviews */}
      <section className="cs-bg-dark py-5 cs-section home-about">
        <Container>
          <Row>
            <Col md={7} xs={12} className="p-0 text-left reviews-home">
              <GoogleReviews />
            </Col>
            <Col md={5} className="d-none d-md-block">
              <img
                className="rounded shadow"
                width={"100%"}
                src="/assets/frontend/images/bbrboat2.jpg"
                alt="BBR Boat"
                style={{ height: "100%", objectFit: "cover" }}
              />
            </Col>
          </Row>
        </Container>
      </section>

    </>
  );
}

